module.exports = __webpack_public_path__ + "static/media/makeover_brand_banner.a97dfb9f.png";